import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";
import { getFullDate, handleImageLink } from "helpers/Function";

const BlogIndex = () => {
	const [articles, setArticles] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع المقالات",
				breadcrumb: "المدونة",
				button: {
					permissions: ["blog-create"],
					show: true,
					text: "اضافة مقال جديد",
					link: "/blog/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/blogs`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setArticles(response.data.data.blogs);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const columns = [
		{
			name: "الصورة",
			selector: "image",
			sortable: true,
			cell: row => (
				<img
					src={handleImageLink(row?.image)}
					style={{ width: "100px", height: "70px", objectFit: "cover" }}
					alt=""
				/>
			),
			width: "120px",
		},
		{
			name: "العنوان",
			selector: "title",
			sortable: true,
			cell: row => row?.title?.ar || row?.title,
		},
		{
			name: "عدد المشاهدات",
			selector: "views",
			sortable: true,
		},
		{
			name: "تاريخ النشر",
			sortable: true,
			cell: row => getFullDate(row?.created_at, "ar"),
		},
		{
			name: "تاريخ التعديل",
			sortable: true,
			cell: row => getFullDate(row?.updated_at, "ar"),
		},
		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					{checkPermissions(["blog-edit"]) && (
						<li className="list-inline-item">
							<Link className="bt bt-sm bt-success" to={`/blog/show/${row.id}`}>
								<i className="fas fa-edit"></i>
							</Link>
						</li>
					)}
					{checkPermissions(["blog-delete"]) && (
						<li className="list-inline-item">
							<button
								className="bt bt-sm bt-danger"
								onClick={() => handleConfrimDelete(row.id)}
								type="button"
								title="حذف المقال"
								aria-label="حذف المقال"
							>
								<i className="fas fa-trash"></i>
							</button>
						</li>
					)}
				</ul>
			),
		},
	];

	const handleConfrimDelete = articleID => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteArticle(articleID),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteArticle = articleID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/blogs/${articleID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setArticles(response.data.data);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={articles}>
					<DataTable
						noHeader
						pagination
						highlightOnHover
						striped
						direction="rtl"
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default BlogIndex;
